<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="0">
          <el-step title="海运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step :title="$t('i18n_confirm_order')"></el-step>
          <el-step :title="$t('i18n_order_completed')"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <!-- ---送货上门--- -->
        <div class="Item_list">
          <div class="cangkutit" style="margin-right: 50px">
            {{ cangkuitem.namec }}
          </div>
          <div class="cangkutit" style="margin-right: 50px">
            <!-- <img src="../../assets/images/setIcon.png" alt=""> -->
            <img style="width: 60px" src="../../assets/setIcon.png" alt="" />
          </div>
          <div class="cangkutit">
            {{ PScangkuitem.namec }}
            <!-- <span style="margin-left: 15px; font-size: 16px; color: #343434">{{
              Citydata.namec
            }}</span> -->
          </div>
        </div>
        <!-- ---上门提货--- -->
        <div class="Item_list">
          <div style="width: 100%">
            <el-checkbox v-model="tuoCheData.checked" @change="changeTi"
              >发货地上门提货</el-checkbox
            >
          </div>
          <div style="width: 100%; float: left" v-show="tuoCheData.checked">
            <div style="padding: 25px 0 0 25px; box-sizing: border-box">
              <el-form
                label-position="left"
                label-width="80px"
                :model="tuoCheData"
              >
                <el-form-item :label="$t('i18n_pickup_location')">
                  <!-- <el-input v-model="newTihuoarr"></el-input> -->
                  <div
                    @click="changeCheic()"
                    style="
                      width: 344px;
                      height: 36px;
                      background: #ffffff;
                      border: 1px solid #e7e7e7;
                      border-radius: 5px;
                    "
                  >
                    <span style="float: left"
                      ><i
                        style="font-size: 16px; padding: 0 5px"
                        class="el-icon-location-outline"
                      ></i
                    ></span>
                    <span
                      style="
                        width: 290px;
                        height: 33px;
                        overflow: hidden;
                        display: inline-block;
                      "
                      >{{ msgFormSon.parvince }}{{ msgFormSon.city
                      }}{{ msgFormSon.area }}{{ msgFormSon.address }}</span
                    >
                    <span style="float: right"
                      ><i class="el-icon-arrow-right"></i
                    ></span>
                  </div>
                </el-form-item>
                <el-form-item label="提货日期">
                  <div class="block">
                    <el-date-picker
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 344px"
                      v-model="todoordate"
                      type="date"
                      placeholder="选择日期"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <!-- ---送货上门--- -->
        <div class="Item_list">
          <el-checkbox v-model="PSFmoney.checked" @change="changeSh"
            >目的地送货上门</el-checkbox
          >
          <div style="width: 100%; float: left" v-show="PSFmoney.checked">
            <div style="padding: 25px 0 0 25px; box-sizing: border-box">
              <el-form
                label-position="left"
                label-width="80px"
                :model="tuoCheData"
              >
                <el-form-item label="配送地点">
                  <!-- <el-input v-model="newTihuoarr"></el-input> -->
                  <div
                    @click="showPStable()"
                    style="
                      width: 344px;
                      height: 36px;
                      background: #ffffff;
                      border: 1px solid #e7e7e7;
                      border-radius: 5px;
                    "
                  >
                    <span style="float: left"
                      ><i
                        style="font-size: 16px; padding: 0 5px"
                        class="el-icon-location-outline"
                      ></i
                    ></span>
                    <span
                      style="
                        width: 290px;
                        height: 33px;
                        overflow: hidden;
                        display: inline-block;
                      "
                      >{{ msgFormPS.country }}{{ msgFormPS.city
                      }}{{ msgFormPS.area }}{{ msgFormPS.address }}</span
                    >
                    <span style="float: right"
                      ><i class="el-icon-arrow-right"></i
                    ></span>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>


        <div class="demoLIst">
          <el-form
            label-width="58px"
            label-position="left"
            class="demo-dynamic"
            size="mini"
            :model="ruleform"
            ref="ruleform"
          >
            <div
              class="Item_list"
              v-for="(item, index) in ruleform.formLIst"
              :key="index"
            >
              <el-row :gutter="5" style="margin-bottom: 15px">
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="品名"
                    :prop="'formLIst.' + index + '.goodsname'"
                    :rules="moreNotOjb.goodsNotname"
                  >
                    <div @click="showgoodsType(index)">
                      <el-input readonly v-model="item.goodsname" size="mini">
                        <i slot="suffix" class="el-icon-arrow-right"></i>
                      </el-input>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="类型"
                    :rules="moreNotOjb.goodsNotname"
                  >
                    <div @click="showgoodsType(index)">
                      <el-input readonly v-model="item.goodstype" size="mini">
                        <i slot="suffix" class="el-icon-arrow-right"></i>
                      </el-input>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="件数"
                    :prop="'formLIst.' + index + '.piece'"
                    :rules="moreNotOjb.PRiceNotname"
                  >
                    <el-input
                      v-model.number="item.piece"
                      @input="(e) => (item.piece = isSize(e))"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="重量"
                    :prop="'formLIst.' + index + '.weight'"
                    :rules="moreNotOjb.KGNotName"
                  >
                    <el-input
                      size="mini"
                      @change="getHTFcount(), getTimoney()"
                      :min="0"
                      :max="999"
                      v-model="item.weight"
                      placeholder="请输入重量"
                    >
                      <i slot="suffix">(KG)</i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    class="rules"
                    label="体积"
                    :prop="'formLIst.' + index + '.cbm'"
                    :rules="moreNotOjb.CBMNotName"
                  >
                    <el-input
                      size="mini"
                      @change="getHTFcount(), getTimoney()"
                      :min="0"
                      :max="999"
                      v-model="item.cbm"
                      placeholder="请输入体积"
                    >
                      <i slot="suffix">(CBM)</i>
                    </el-input>
                    <div
                      v-if="item.heavyUnitPrice != '0'"
                      style="
                        width: 100%;
                        border-radius: 14px;
                        background: #f3eac5;
                        margin-top: 5px;
                      "
                    >
                      <div
                        style="
                          font-size: 22rpx;
                          font-family: PingFang SC;
                          font-weight: 500;
                          color: #9b791e;
                        "
                      >
                        此商品超重，适用重货报价：￥{{ item.heavyUnitPrice }}
                      </div>
                    </div>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <div class="Iteminput">
                    <div style="min-width: 56px">尺寸(cm)</div>
                    <div>
                      <el-col :span="8"
                        ><el-input oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}" size="mini" v-model="item.l"
                          ><i
                            slot="suffix"
                            style="margin-top: 5px; display: inline-block"
                            >长</i
                          >
                        </el-input></el-col
                      >
                      <el-col :span="8"
                        ><el-input
                          size="mini"
                           oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                          v-model="item.w"
                          placeholder="宽"
                          ><i slot="suffix" style="margin-top: 5px; display: inline-block">宽</i></el-input></el-col>
                      <el-col :span="8"
                        ><el-input
                          size="mini"
                          v-model="item.h"
                          placeholder="高"
                           oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                          
                          ><i
                            slot="suffix"
                            style="margin-top: 5px; display: inline-block"
                            >高</i
                          ></el-input
                        ></el-col
                      >
                    </div>
                  </div>
                </el-col>
              </el-row>
              <!-- <el-button size="mini" @click="deleteRules(item, index)" >删除</el-button> -->
              <div style="width: 100%">
                <el-button
                  v-show="index == ruleform.formLIst.length - 1"
                  type="primary"
                  size="mini"
                  @click="addItem('ruleform')"
                  >+增加更多</el-button
                >
                <el-button
                  icon="el-icon-delete"
                  size="mini"
                  style="background: #eeeeee"
                  v-if="ruleform.formLIst.length > 1"
                  @click="handleDelete(index, item)"
                  >删除</el-button
                >
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          {{$t('i18n_cost_calculation')}}
        </p>
        <div class="Item_Right animate__animated animate__bounceInRight">
          <p class="tit">海运费</p>
          <p
            class="coutText"
            v-for="(item, index) in HYFmoney.goodsTypeFeeDTOS"
            :key="index"
          >
            <span class="littit">{{ item.goodsTypeName }}</span>
            <span class="fontString">{{ item.currency }}{{ item.amount }}</span>
            <span style="margin-left:10px">({{item.calDesc}})</span>
          </p>
          <p class="coutText">
            <span class="littit">{{$t('i18n_subtotal')}}</span>
            <span class="fontString"
              >{{ HYFmoney.currency }}{{ HYFmoney.amount }}</span
            >
          </p>
        </div>
        <div
          class="Item_Right animate__animated animate__bounceInRight"
          v-show="tuoCheData.checked"
        >
          <p class="tit">提货费 <span v-if="tuoCheData.minKilometer" style="font-size:13px;float: right;font-weight: 500;">({{tuoCheData.minKilometer+'KM'}}--{{tuoCheData.maxKilometer+'KM'}})</span> </p>
          <p class="coutText">
            <span class="littit">发货地上门提货</span>
            <span class="fontString"
              >{{ tuoCheData.currency }}{{ tuoCheData.amount }}</span
            >
          </p>
        </div>
        <div
          class="Item_Right animate__animated animate__bounceInRight"
          v-show="PSFmoney.checked"
        >
          <p class="tit">配送费</p>
          <p class="coutText">
            <span class="littit">目的地送货上门</span>
            <span class="fontString"
              >{{ PSFmoney.currency }}{{ PSFmoney.amount }}</span
            >
          </p>
        </div>
        <div class="Item_Right">
          <p class="">
            <span class="littit">合计费用</span>
            <span
              v-for="(item, index) in this.newArray"
              :key="index"
              v-show="item.amount > 0"
            >
              <span
                ><span class="fontString" v-show="item.currency != ''">{{
                  item.currency
                }}</span>
                <span
                  class="fontString"
                  v-show="item.amount > 0"
                  style="margin-left: 5px; margin-right: 5px"
                  >{{ item.amount }}</span
                ></span
              >
              <span v-show="index == newArray.length - 1 ? false : true"
                >+</span
              >
            </span>
          </p>
          <p class="coutText">
            <span class="littit">折合人民币</span>
            <span class="fontString">CNY {{ calculatePrice }}</span>
          </p>
        </div>
        <div style="width: 100%; margin-top: 130px; float: left">
          <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()"
              >上一步</el-button
            >
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-button
              style="width: 100%; background: #604aff; color: #ffffff"
              @click="pathToNext('ruleform')"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- -----------提货联系人 -->
    <el-dialog
      class="table_wrap"
      title="提货地址"
      :modal-append-to-body="false"
      :visible.sync="dialogFormVisible"
      :SonshowType-val="SonshowType"
    >
      <div class="coutn_show">
        <sonComponents
          @func="getMsgFormSon"
          ref="mychild"
          :contactype2="contactype2"
          :tableData="tableData"
        ></sonComponents>
      </div>
      <div slot="footer" class="dialog-footer header_wrap" style="height:35px">
        <!-- <el-button type="primary" v-show="SonshowType" @click="Qdchange()">确认选择</el-button> -->
        <el-alert
          title="点击任意一行选择您的地址"
          type="info"
          center
          show-icon>
        </el-alert>
      </div>
    </el-dialog>
    <!-- -----------联系人end -->

    <!-- 收货联系人 -->
    <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
      <div
        style="
          width: 100%;
          float: left;
          padding: 15px 15px;
          box-sizing: border-box;
        "
      >
        <div class="addcalss" @click="addbtn()">
          <i
            :class="
              !addType
                ? 'el-icon-circle-plus-outline'
                : 'el-icon-remove-outline'
            "
          ></i>
          {{ !showType ? "添加地址" : "修改地址" }}
        </div>
      </div>

      <el-collapse-transition>
        <div
          class="coutn_show"
          v-show="addType"
          style="width: 100%; float: left"
        >
          <div style="padding: 15px; border: 1px solid #33">
            <div class="Iteminput">
              <div style="min-width: 60px">联系人</div>
              <div style="width: 100%">
                <el-input
                  :maxlength="10"
                  :show-word-limit="true"
                  clearable
                  style="width: 100%"
                  v-model="form.name"
                ></el-input>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">联系方式</div>
              <div style="width: 100%">
                <el-input
                  :maxlength="13"
                  style="width: 100%"
                  clearable
                  v-model="form.tel"
                ></el-input>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">联系地址</div>
              <div style="width: 100%">
                <el-cascader
                  style="width: 100%"
                  v-model="shouaddressid"
                  :options="WaicountLIst"
                  :props="defaultParams"
                  @change="handleChange"
                ></el-cascader>
              </div>
            </div>

            <div class="Iteminput">
              <div style="min-width: 60px">详细地址</div>
              <div style="width: 100%">
                <el-input style="width: 100%" v-model="form.address"></el-input>
              </div>
            </div>
          </div>
          <div style="width: 100%; height: 50px; text-align: center">
            <el-button v-show="!showType" type="primary" @click="Qdback('I')"
              >确定</el-button
            >
            <el-button v-show="showType" type="primary" @click="Qdback('U')"
              >修改</el-button
            >
            <el-button
              type="success"
              @click="(addType = false), (showType = false)"
              >取消</el-button
            >
          </div>
        </div>
      </el-collapse-transition>

      <div style="width: 100%; float: left;" v-show="!addType">
        <el-table
          
          height="400"
          tooltip-effect="dark"
          :data="
            PStablelist.filter(
              (data) =>
                !searchPSname ||
                data.name.toLowerCase().includes(searchPSname.toLowerCase())
            )
          "
          highlight-current-row
          border
          ref="Table"
          style="width: 100%;cursor:pointer"
         @row-click="getCurrentRow"
        >
          <!-- <el-table-column label="选择" width="65">
            <template slot-scope="scope">
              <el-checkbox
                :label="scope.$index"
                v-model="scope.row.changeType"
                @change.native="getCurrentRow(scope.row)"
                >&nbsp;
              </el-checkbox>
            </template>
          </el-table-column> -->
          <el-table-column label="姓名" width="100" align="center" prop="name">
          </el-table-column>
          <el-table-column label="电话" width="120" align="center" prop="tel">
          </el-table-column>
          <el-table-column
            label="联系地址"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.country }}
              {{ scope.row.city }}
              {{ scope.row.area }}
              {{ scope.row.address }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="160">
            <template slot="header" slot-scope="scope">
              <el-input
                v-model="searchPSname"
                size="mini"
                placeholder="请输入姓名"
              />
            </template>
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click.stop="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click.stop="delpsItem(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer header_wrap" style="height:35px">
        <el-alert
          title="点击任意一行选择您的地址"
          type="info"
          center
          show-icon>
        </el-alert>
        <!-- <el-button type="primary" @click="QdPSchange()" v-show="!addType">确认选择</el-button> -->
      </div>
    </el-dialog>

    <el-dialog :visible.sync="goodsTypeShow" class="goodsTypeShow">
      <div style="padding:30px 0">
        <el-tabs tab-position="left">
          <el-tab-pane
            style="color: red"
            v-for="(item, index) in tabbar"
            :key="index"
            :label="item.namec"
          >
            <div
              style="
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #333333;
                margin-bottom: 11px;
              "
            >
              {{ item.namec }}
            </div>
            <div
              v-for="(_item, _index) in item.datItemInfoDTOList"
              :key="_index"
              style="float: left; margin-right: 5px"
            >
              <el-button
                size="mini"
                type="info"
                plain
                @click="changeGoodstype(_item, index)"
                >{{ _item.namec }}</el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sonComponents from "./userArrdata.vue";
import qs from "qs";
export default {
  components: {
    sonComponents,
  },
  data() {
    return {
      goodsTypeindex: "",
      tabbar: [],
      goodsTypeShow: false,
      moreNotOjb: {
        PRiceNotname: [
          { required: true, message: "件数不能为空" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error("长度只能为1-15个字符"));
              } else {
                var reg = /^[1-9]\d*$/;
                if (!reg.test(value)) {
                  callback(new Error("件数不能小于等于0"));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        goodsNotname: [{ required: true, message: "品名不能为空" }],
        KGNotName: [
          { required: true, message: "重量不能为空" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error("长度只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("重量只能大于零且保留最多两位小数"));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
        CBMNotName: [
          { required: true, message: "体积不能为空" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 15 || value.length < 1) {
                callback(new Error("长度只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("体积只能大于零且保留最多两位小数"));
                } else {
                  callback();
                }
              }
            },
            trigger: "change",
          },
        ],
      },

      SonshowType: true,
      defaultParams: {
        label: "namec",
        value: "namec",
        children: "children",
      },
      shouaddressid: [],
      WaicountLIst: [],
      showType: false,
      addType: false,
      dialogTableVisible: false,
      Timeshow: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      auto_fixed: false,
      cbm: null,
      tableData: [],
      Citydata: null,
      cangkuitem: null,
      guojiaData: null,
      PStablelist: [],
      searchPSname: "",
      HYFmoney: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      PSFmoney: {
        checked: false,
        name: "配送费",
        feeCode: "SDYF",
        feeType: "A",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      newTihuoarr: "", //需展示的提货地址
      todoordate: null,
      tuoCheData: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        minKilometer:'',
        maxKilometer:'',
      },
      ruleform: {
        formLIst: [
          {
            goodsitemid:'',
            goodsname: null, //品名
            goodstype: "",
            goodstypeid: "",
            piece: null, //件数
            weight: null, //重量
            cbm: null, //体积
            heavyUnitPrice: "0",
            l: "0", //长
            w: "0", //宽
            h: "0", //高
            markno: "0", //唛头
          },
        ],
      },
      msgFormSon: {},
      msgFormPS: localStorage.getItem("countLIst_C")? JSON.parse(localStorage.getItem("countLIst_C")): {}, //当前展示 收货地址
      contactype2: "",
      dialogFormVisible: false,
      totalMolist: [],
      clickPsitem: {}, //当前点击收货地址item
      form: {
        country: "",
        city: "",
        area: "",
        address: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      setLIstdata: [],
    };
  },
  watch: {},
  computed: {
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let PSFmoney = 0; //配送费
      let HYFmoney = 0; //海运费
      let THFmoney = 0; //提货费
      HYFmoney = this.HYFmoney.cnyamount ? +this.HYFmoney.cnyamount : 0;
      if (this.PSFmoney.checked) {
        //如果有配送费
        PSFmoney = this.PSFmoney.cnyamount ? +this.PSFmoney.cnyamount : 0;
      }
      if (this.tuoCheData.checked) {
        //如果有提货费
        THFmoney = this.tuoCheData.cnyamount ? +this.tuoCheData.cnyamount : 0;
      }
      Totalmoney = HYFmoney + PSFmoney + THFmoney;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.HYFmoney))); //海运费币种
      if (this.PSFmoney.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.PSFmoney))); //配送费币种
      }
      if (this.tuoCheData.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.tuoCheData))); //提货费费币种
      }
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    showgoodsType(index) {
      this.goodsTypeShow = true;
      this.goodsTypeindex = index;
    },
    changeGoodstype(item) {
      this.goodsTypeShow = false;
      this.goodsTypeindex; //当前对应的商品
      console.log(item);
      this.ruleform.formLIst[this.goodsTypeindex].goodsname = item.namec;
      this.ruleform.formLIst[this.goodsTypeindex].goodstype = item.goodstype;
      this.ruleform.formLIst[this.goodsTypeindex].goodstypeid =item.goodstypeid;
      this.ruleform.formLIst[this.goodsTypeindex].goodsitemid =item.id;
      this.getHTFcount();
    },
    deleteRules(item, index) {
      var index = this.ruleform.formLIst.indexOf(item);
      if (index !== -1) {
        this.ruleform.formLIst.splice(index, 1);
      }
    },

    SonchangeShow() {
      this.SonshowType = true;
    },
    SonchangeHide() {
      this.SonshowType = false;
    },
    handleEdit(index, row) {
      //编辑
      this.showType = true;
      this.shouaddressid = [];
      console.log(row);
      this.addType = true;
      this.form.customerid = row.customerid;
      this.form.id = row.id;
      this.form.isdefault = row.isdefault;
      this.form.name = row.name;
      this.form.tag = row.tag;
      this.form.tel = row.tel;
      this.form.country = row.country;
      this.form.city = row.city;
      this.form.area = row.area;
      this.form.address = row.address;
      this.shouaddressid.push(row.country);
      this.shouaddressid.push(row.city);
      this.shouaddressid.push(row.area);
      console.log(this.shouaddressid);
      this.setLIstdata = this.shouaddressid;
    },
    delpsItem(index, row) {
      let that = this;
      this.$confirm("确定删除该联系人吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post(`/customer/delAddress/${row.id}`)
            .then((res) => {
              if (res.data.code == "200") {
                that.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.getPspletable(); //刷新查询列表
              } else {
                that.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addbtn() {
      this.showType = false;
      this.addType = !this.addType;
    },
    Qdback(Type) {
      if (Type == "I") {
        this.form.id = "";
      }
      if (this.form.name == "") return this.$message("请输入联系人姓名");
      if (this.form.tel == "") return this.$message("请输入联系人电话");
      if (this.form.setLIstdata == []) return this.$message("请选择省市区");
      if (this.form.address == "") return this.$message("请输入详细地址");
      let that = this;
      let params = {
        customerid: JSON.parse(localStorage.getItem("Authorization"))
          .customerid, //客户id
        id: this.form.id,
        isdefault: this.form.isdefault,
        name: this.form.name,
        tag: "",
        tel: this.form.tel,
        country: this.setLIstdata[0],
        city: this.setLIstdata[1],
        area: this.setLIstdata[2],
        address: this.form.address,
      };
      this.axios
        .post(`/customer/addOrUpdateConsigner`, params)
        .then((res) => {
          if (res.data.code == "200") {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getPspletable(); //刷新查询列表
            this.form.customerid = "";
            this.form.name = "";
            this.form.tel = "";
            this.form.city = "";
            this.form.address = "";
            this.form.id = "";
            this.form.area = "";
            this.form.country = "";
            this.setLIstdata = [];
            this.shouaddressid = [];
            this.showType = false;
            this.addType = false;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    handleChange(value) {
      console.log(value);
      this.setLIstdata = value;
    },
    QdPSchange() {
      console.log(this.clickPsitem);
      if (!this.clickPsitem.name)
        return this.$message({
          showClose: true,
          message: "请选择地址",
          type: "warning",
        });
      this.msgFormPS = this.clickPsitem;
      this.dialogTableVisible = false;
      localStorage.setItem("countLIst_C", JSON.stringify(this.msgFormPS));
      this.getPSFcount(); //重新计算配送费
    },
    getCurrentRow(row) {
      this.msgFormPS = row
      this.dialogTableVisible = false;
      localStorage.setItem("countLIst_C", JSON.stringify(this.msgFormPS));
      this.getPSFcount(); //重新计算配送费

      // this.PStablelist.forEach((item) => {
      //   item.changeType != item.changeType;
      //   if (item.id !== row.id) {
      //     item.changeType = false;
      //   }
      //   if (item.changeType) {
      //     this.clickPsitem = item;
      //   }
      // });
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    isSize(val) {
      val = val.replace(/[^0-9]/gi, "");
      return val;
    },
    isnumber(val) {
      val = val.replace(/\d+(\.\d{0,2})?/, "");
      return val;
    },
    changeNum(index, num, type) {},
    changeSh() {
      console.log("123");
      this.PSFmoney.checked != this.PSFmoney.checked;
      if (this.PSFmoney.checked) {
        this.getPSFcount();
      }
    },
    changeTi() {
      this.tuoCheData.checked != this.tuoCheData.checked;
      if (this.tuoCheData.checked) {
        this.getTimoney();
      }
    },
    pathToNext(formName) {
      let flag = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      let that = this;
      this.ruleform.formLIst.forEach((item, index) => {
        for (var key in item) {
          if (!item[key]) {
            flag = false;
            return this.$message("请输入商品完整信息");
          } else {
            flag = true;
          }
        }
      });

      if (this.tuoCheData.checked) {
        //如果勾选了提货
        if (!this.msgFormSon.parvince) return this.$message("请选择上门提货地址");
        if (this.todoordate == null) return this.$message("请选择上门提货时间");
        localStorage.setItem("todoorTime", this.todoordate); //提货时间
      } else {
        localStorage.removeItem("todoorTime");
        localStorage.removeItem("countLIst_T");
      }
      localStorage.setItem("busLcljobsBeforeGoodsDTOList",JSON.stringify(this.ruleform.formLIst)); //商品信息
      localStorage.setItem("todoordate", JSON.stringify(this.tuoCheData)); //提货费
      localStorage.setItem("HYFmoney", JSON.stringify(this.HYFmoney)); //海运费
      localStorage.setItem("PSFmoney", JSON.stringify(this.PSFmoney)); //配送费

      if (this.PSFmoney.checked) { //如果勾选了配送
        //校验路线正确
        if(!this.msgFormPS.country) return this.$message("请选择送货地址");
        let params = {};
        let that = this;
        params = {
          recgoodsCountry: this.msgFormPS.country,
          toWarehouseId: this.PScangkuitem.id,
        };
        this.axios
          .post(`/busLcljobsBefore/validateWarehouseCountry`,
            qs.stringify(params)
          )
          .then((res) => {
            if (res.data.code == "200") {
              if (flag) {
                this.$router.push({
                  name: "newservice",
                });
              }
            } else {
              this.$alert(res.data.message, "错误", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.$message({
                    type: "info",
                    message: `请重新选择送货上门地址`,
                  });
                },
              });
            }
          })
          .catch((res) => {
            this.$message.info("服务器繁忙");
          });
      }else{
        if (flag) {
          this.$router.push({
            name: "newservice",
          });
        }
      }
      
    },
    pathToback() {
      this.$router.go(-1);
    },

    Qdchange() {
      //确定选择
      this.$refs.mychild.changesonItem();
      if (this.msgFormSon.parvince) {
        0;
        this.dialogFormVisible = false;
        this.Timeshow = true;
        this.getTimoney(); //重新计算提货费
        // this.getSontime(); //获取最早时间
      } else {
        this.$message({
          showClose: true,
          message: "请选择地址",
          type: "warning",
        });
      }
    },
    getHTFcount() {
      //获取海运费
      this.loadin = true;
      let that = this;
      let itemDTOS = [];
      this.ruleform.formLIst.forEach((item, index) => {
        let goodItem = {
          cbm: 0,
          weight: 0,
          goodsTypeId: "",
        };
        goodItem.cbm = item.cbm;
        goodItem.goodsTypeId = item.goodstypeid;
        goodItem.weight = item.weight;
        itemDTOS.push(goodItem);
      });

      let params = {
        feeCode: "QBHYF",
        pollandId: JSON.parse(localStorage.getItem("cangkuitem")).id, //起运地id,
        podlandId: JSON.parse(localStorage.getItem("PScangkuitem")).id, //目的地仓库
        customerId: JSON.parse(localStorage.getItem("Authorization")).customerid, //客户id
        itemDTOS: itemDTOS,
      };
      this.axios
        .post(`/feeitem/getSeaFeeQuoteInfo`, params)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == "200") {
            that.HYFmoney.price = res.data.data.price;
            that.HYFmoney.currency = res.data.data.currency;
            that.HYFmoney.cnyprice = res.data.data.price;
            that.HYFmoney.piece = 1;
            that.HYFmoney.amount = res.data.data.amount;
            that.HYFmoney.cnyamount = res.data.data.cnyamount;
            that.HYFmoney.goodsTypeFeeDTOS = res.data.data.goodsTypeFeeDTOS;
            that.ruleform.formLIst.forEach((item, index) => {
              item.goodstype = res.data.data.itemDTOS[index].goodsTypeName;
              item.heavyUnitPrice =res.data.data.itemDTOS[index].heavyUnitPrice;
            });
          } else {
            that.HYFmoney.cnyamount = 0;
            that.HYFmoney.amount = 0;
            that.HYFmoney.price = "";
            that.HYFmoney.currency = "";
            that.HYFmoney.cnyprice = "";
            that.HYFmoney.goodsTypeFeeDTOS = [];
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getTimoney() {
      //获取提货费
      let that = this;
      let weight = 0,
        cbm = 0;
      this.ruleform.formLIst.forEach((item, index) => {
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      let params = {};
      params = {
        province: localStorage.getItem("countLIst_T")
          ? JSON.parse(localStorage.getItem("countLIst_T")).parvince
          : "", //省 name
        city: localStorage.getItem("countLIst_T")
          ? JSON.parse(localStorage.getItem("countLIst_T")).city
          : "", //市 name
        area: localStorage.getItem("countLIst_T")
          ? JSON.parse(localStorage.getItem("countLIst_T")).area
          : "", //区 name
        customerId: JSON.parse(localStorage.getItem("Authorization"))
          .customerid, //客户id
        feeCode: "THF",
        inWarehouseId: JSON.parse(localStorage.getItem("cangkuitem")).id,
        weight: weight,
        cbm: cbm,
      };
      this.axios
        .post(`/feeitem/getVASPriceForPickUp`, params)
        .then((res) => {
          console.log(res)
          if (res.data.code == "200") {
            that.tuoCheData.price = res.data.data.price; //价格
            that.tuoCheData.currency = res.data.data.currency; //币种
            that.tuoCheData.cnyprice = res.data.data.cnyprice; //--隐藏单价
            that.tuoCheData.cnycurrency = res.data.data.cnycurrency; //”CNY”--换算币种
            that.tuoCheData.cnyamount = res.data.data.cnyprice; //”CNY”--换算币种
            that.tuoCheData.amount = res.data.data.price;
            that.tuoCheData.piece = 1;
            that.tuoCheData.maxKilometer = res.data.data.maxKilometer
            that.tuoCheData.minKilometer = res.data.data.minKilometer
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    getPSFcount() {
      //获取配送费 送货上门
      this.loadin = true;
      let that = this;
      let params = {
        customerId: JSON.parse(localStorage.getItem("Authorization"))
          .customerid, //客户id
        feeCode: "SDYF",
        podlandId: localStorage.getItem("countLIst_C")
          ? JSON.parse(localStorage.getItem("countLIst_C")).countryId
          : "", //目的国id
        podlandCityId: localStorage.getItem("countLIst_C")
          ? JSON.parse(localStorage.getItem("countLIst_C")).cityId
          : "", //目的城市id
        podlandAreaId: localStorage.getItem("countLIst_C")
          ? JSON.parse(localStorage.getItem("countLIst_C")).areaId
          : "", //目的区域id
        toWarehouseId: localStorage.getItem("countLIst_C")
          ? JSON.parse(localStorage.getItem("PScangkuitem")).id
          : "",
        sendSecond: "N",
      };
      this.axios
        .post(`/feeitem/getVASPriceForDelivery`, params)
        .then((res) => {
          console.log(res);
          that.PSFmoney.price = res.data.data.price;
          that.PSFmoney.currency = res.data.data.currency; //币种
          that.PSFmoney.cnycurrency = res.data.data.cnycurrency; //币种
          that.PSFmoney.cnyprice = res.data.data.cnyprice; //单价
          that.PSFmoney.cnyamount = res.data.data.cnyprice;
          that.PSFmoney.amount = res.data.data.price;
          that.PSFmoney.piece = 1;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    addItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleform.formLIst.push({
            goodsitemid:'',
            goodsname: "", //品名
            goodstype: "",
            goodstypeid: "",
            heavyUnitPrice: "0",
            piece: "", //件数
            weight: "", //重量
            cbm: "", //体积
            l: "0", //长
            w: "0", //宽
            h: "0", //高
            markno: "0", //唛头
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // let type = false;
      // let itemobj = {
      //   goodsname: "", //品名
      //   piece: "", //件数
      //   weight: "", //重量
      //   cbm: "", //体积
      //   l: "0", //长
      //   w: "0", //宽
      //   h: "0", //高
      //   markno: "0", //唛头
      // };
      // this.ruleform.formLIst.forEach((item, index) => {
      //   for (var key in item) {
      //     type = false;
      //     if (!item.weight) return this.$message({ message: "请输入商品重量" });
      //     if (!item.cbm) return this.$message({ message: "请输入商品体积" });
      //     if (!item.goodsname)
      //       return this.$message({ message: "请输入商品名称" });
      //     if (!item.piece) return this.$message({ message: "请输入商品件数" });
      //     type = true;
      //   }
      // });
      // if (type) {
      //   this.ruleform.formLIst.push(itemobj);
      // }
    },
    handleDelete(index) {
      //删除
      this.$confirm("确定删除该商品信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ruleform.formLIst.splice(index, 1);
          this.getHTFcount();
          this.getTimoney()
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    GetgoodsType() {
      let that = this;
      this.axios
        .get(`/filedata/findItemCategoryAll`)
        .then((res) => {
          if (res.data.code == "200") {
            console.log(res.data.datas);
            that.tabbar = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getProvinces() {
      //获取国外地址
      let customerid = JSON.parse(sessionStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .post(`/filedata/findThirdLevelAddress`)
        .then((res) => {
          console.log(res);
          this.WaicountLIst = res.data.datas;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getMsgFormSon(data) {
      //提货确定
      this.msgFormSon = data;
    },
    hindDing(){
        console.log('123123')
        this.getTimoney()
        this.dialogFormVisible = false
    },
    showPStable() {
      //点击打开配送地址
      this.dialogTableVisible = true;
      this.getPspletable();
    },
    changeCheic() {
      this.dialogFormVisible = true;
      this.contactype2 = "T";
    },
    getPspletable() {
      //获取收货地址
      let that = this;
      let customerId = JSON.parse(localStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForConsigner/${customerId}`)
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            res.data.datas.forEach((item) => {
              this.$set(item, "changeType", false);
            });
            this.PStablelist = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = JSON.parse(localStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForDelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            res.data.datas.forEach((item) => {
              this.$set(item, "changeType", false);
            });
            this.tableData = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // getSontime() {
    //   //获取最早提货时间
    //   this.loadin = true;
    //   let that = this;
    //   let params = {
    //     area: this.msgFormSon.area,
    //     city: this.msgFormSon.city,
    //     inWarehouseId: JSON.parse(localStorage.getItem("cangkuitem")).id,
    //     province: this.msgFormSon.parvince,
    //   };
    //   let TimeWrap = "";
    //   this.axios
    //     .post(`/finance/calEarlistPickUpGoodsTime`, params)
    //     .then((res) => {
    //       if (res.data.code == "200") {
    //         this.pickerOptions0 = {
    //           disabledDate(time) {
    //             var date = new Date(`${res.data.data} 24:00:00:000`);
    //             var thatDay = date.getTime() - 8.64e7;
    //             return time.getTime() < thatDay;
    //           },
    //         };
    //       } else {
    //         this.pickerOptions0 = {
    //           disabledDate(time) {
    //             return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
    //           },
    //         };
    //       }
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //     });
    // },
    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
  },
  created() {
    console.log(this.$route.params);

    this.Citydata = JSON.parse(localStorage.getItem("Citydata"));
    this.cangkuitem = JSON.parse(localStorage.getItem("cangkuitem"));
    this.PScangkuitem = JSON.parse(localStorage.getItem("PScangkuitem"));

    if (localStorage.getItem("busLcljobsBeforeGoodsDTOList")) {
      //物品信息
      this.ruleform.formLIst = JSON.parse(
        localStorage.getItem("busLcljobsBeforeGoodsDTOList")
      );
    }
    if (this.$route.params.weight) {
      this.ruleform.formLIst[0].weight = this.$route.params.weight;
    }

    if (this.$route.params.PSFmoneyChecked) {
      this.PSFmoney.checked = this.$route.params.PSFmoneyChecked;
    } else {
      if (localStorage.getItem("PSFmoney")) {
        this.PSFmoney = JSON.parse(localStorage.getItem("PSFmoney"));
      }
    }

    if (this.$route.params.tuoCheDataChecked) {
      this.tuoCheData.checked = this.$route.params.tuoCheDataChecked;
    } else {
      if (localStorage.getItem("todoordate")) {
        this.tuoCheData = JSON.parse(localStorage.getItem("todoordate"));
      }
    }
    if (this.$route.params.cbm) {
      this.ruleform.formLIst[0].cbm = this.$route.params.cbm;
    }
    if (localStorage.getItem("countLIst_T")) {
      this.msgFormSon = JSON.parse(localStorage.getItem("countLIst_T")); //提货信息
      this.todoordate = localStorage.getItem("todoorTime");
    }
  },
  mounted() {
    this.GetgoodsType(); //获取货物类型
    this.getPSFcount(); //配送费
    this.getPeopletable(); //提货通讯录
    this.getPspletable(); //收货通讯录
    this.getHTFcount(); //海运费
    this.getProvinces(); //获取国外地址
    this.getTimoney();
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
  },
};
</script>
<style scoped>
.fontString {
  font-weight: bold;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
.goodsTypeShow >>> .el-dialog__body {
  padding: 0 !important;
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}
.Item_Right {
  float: left;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1098px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 34px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 764px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 35px;
  box-sizing: border-box;
}
.wrap_R {
  float: right;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  /* position: sticky;
  top: 0px; */
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
.addcalss {
  color: #fff;
  background-color: #5f4aff;
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  transition: 0.1s;
  font-weight: 500;
  float: right;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/bulkCargo.vue